// extracted by mini-css-extract-plugin
module.exports = {"reviewsWrapper":"f6","columnsWrapper":"f7","reviewsHeader":"f8","reviews":"f9"};